module.exports = __webpack_public_path__ + "img/2man.bd2ecb4a.png";